module.exports = __webpack_public_path__ + "static/media/ktp_guide_tilted.15f17bce.svg";